define('grid_order_row.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('grid_order_row', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<tr\n  class=\"grid-order-row "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"hasPricesSchedules") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":24},"end":{"line":2,"column":85}}})) != null ? stack1 : "")
    + "\"\n  data-view=\"Cell.Collection\"\n></tr> ";
},"1":function(container,depth0,helpers,partials,data) {
    return " grid-order-row-no-bordered ";
},"useData":true}, 'extensions/SuiteCommerce/GridOrder/1.0.5/', 'extensions/SuiteCommerce/GridOrder/1.0.5/', Handlebars);
});